import { render, staticRenderFns } from "./client-tasks.vue?vue&type=template&id=7bb6ac08&"
import script from "./client-tasks.vue?vue&type=script&lang=js&"
export * from "./client-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports